import { Form, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Endpoints from "../../api/endpoints";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import PageRoutes from "../../utils/routes";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import ApplicationStatusForm from "./ApplicationStatusForm";
import routes from "../../utils/routes";

const UpdateApplicationStatus = () => {
  const [form] = Form.useForm();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const params = useParams();
  const appStatusId = params.appStatusId;

  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const [initialValues, setInitialValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchApplicationStatusDetails();
  }, []);

  const fetchApplicationStatusDetails = async () => {
    setIsLoading(true);
    const httpParams = { id: appStatusId };

    const result = await EndpointFunctions.fetchData({
      axiosPrivate: axiosPrivate,
      endpointURL: Endpoints.getApplicationStatus,
      httpParams: httpParams,
    });

    if (result.success) {
      setIsLoading(false);
      setInitialValues(result.data);
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const updateApplicationStatus = async (values) => {
    setIsLoading(true);
    console.log("---VALUES---", values);

    const requestBody = {
      id: appStatusId,
      minVersion: values.minVersion,
      maxVersion: values.maxVersion,
      os: values.os,
      forceUpdate: values.forceUpdate,
      recommendUpdate: values.recommendUpdate,
      maintenanceMode: values.maintenanceMode,
      app: values.app,
    };
    console.log("---REQUEST BODY---", requestBody);

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.updateApplicationStatus,
      axiosPrivate: axiosPrivate,
      requestBody: requestBody,
    });

    if (result.success) {
      setIsLoading(false);
      showModal("Başarılı", "Uygulama Durumu Güncellendi.", () => {
        closeModal();
        navigate(routes.applicationStatuses);
      });
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <>
      <div>
        <ApplicationStatusForm
          form={form}
          onFinish={updateApplicationStatus}
          initialValues={initialValues}></ApplicationStatusForm>
      </div>

      <Spin spinning={isLoading} fullscreen />

      <ModalComponent></ModalComponent>
    </>
  );
};

export default UpdateApplicationStatus;
